import React, {Component} from 'react'
import I18n from 'app/common/i18n';
import {Field} from 'dk-ui-lib';

class CompanyInfo extends Component {

  render() {
    let {
      className,
      company,
      updateCompanyName,
      showStatus } = this.props;

    let nameError = company.errors && {error: company.errors.name};

    return (
      <div className={'flex justify-between ' + className}>
        <div className='col-7 mr2'>
          <Field
            tabIndex={1}
            value={company.name}
            onChange={updateCompanyName}
            label={`${I18n.t('onboard.company.company')} ${I18n.t('onboard.name')}`}
            inputType={'text'}
            errorPosition='bottom'
            shouldHideValidationMsg={false}
            shouldHideValidationIcon={true}
            shouldHideRedBorder={false}
            msgs={showStatus && nameError}/>
        </div>
      </div>
    );
  }

}

export default CompanyInfo;


// WEBPACK FOOTER //
// ./src/views/company-onboard/CompanyInfo.js